module.exports = __webpack_public_path__ + "static/assets/a711ad702b62445ada5a73f2c40f3b97.svg";